import styled from 'styled-components';
export const StyledListItem = styled.li.withConfig({
  displayName: "GlobalToolbarItem__StyledListItem",
  componentId: "d26ajz-0"
})(["height:auto;display:flex;align-items:center;justify-content:center;margin:0 5px !important;&:hover{background:none !important;}", ""], ({
  additionalStyles
}) => additionalStyles || '');